import { Injectable, signal } from '@angular/core';
import { MenuItem } from 'primeng/api';

@Injectable({ providedIn: 'root' })
export class CustomBreadcrumbState {
  private _customItems = signal<MenuItem[] | null>(null);

  public customItems = this._customItems.asReadonly();

  show(items: MenuItem[]): void {
    this._customItems.set(items);
  }

  clear(): void {
    this._customItems.set(null);
  }
}
